import React, {
	forwardRef,
	memo
} from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Icon,
	Input
} from 'semantic-ui-react';

import { log } from '../../services/utils';

import useToggle from '../../hooks/useToggle';

import styles from './auth.module.css';

const AuthInput = forwardRef( (
	{
		className,
		icon,
		name,
		onChange,
		placeholder,
		type = 'text',
		value,
		...props
	},
	ref
) => {
	const [ showPassword, toggleShowPassword ] = useToggle( false );

	return (
		<>
			{ log( '- authInput' ) }
			<Input
				action
				autoComplete={ type === 'password'
					? 'chrome-off'
					: 'off'
				}
				className={ `${ styles.authInput } ${ className && className }` }
				fluid
				icon
				iconPosition="left"
				name={ name }
				onChange={ onChange }
				placeholder={ placeholder}
				type={ showPassword
					? ''
					: type
				}
				value={ value }
				{ ...props }
			>
				<Icon name={ icon } />
				<input ref={ ref }
					autoCapitalize="off" />
				{ type === 'password'
					&& <Button
						basic
						className={ styles.showButton }
						secondary
						icon={ showPassword
							? 'hide'
							: 'eye'
						}
						onClick={ toggleShowPassword }
					/>
				}
			</Input>
		</>
	);
} );

AuthInput.displayName = 'AuthInput';

AuthInput.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.string,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	type: PropTypes.oneOf( [ 'text', 'password' ] ),
	value: PropTypes.string.isRequired
};

export default memo( AuthInput );
